import { localized } from '@weavedev/lit-i18next';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { getGetPrintPriceList, getGetProductPriceList } from '@/api-sdk';
import { DownloadsMixin } from '@/components/downloads/downloads-mixin';
import { priceListDownloads } from '@/data';
import { DownloadStatus } from '@/types';

import './fg-downloads';

@customElement('fg-price-lists-downloads')
@localized()
export class FgPriceListsDownloads extends DownloadsMixin(LitElement) {
  async firstUpdated() {
    priceListDownloads.forEach(download =>
      this.updateDownloadStatus(download.id, DownloadStatus.INITIAL),
    );
  }

  async downloadPriceList(event: CustomEvent) {
    const { download } = event.detail;

    this.updateDownloadStatus(download.id, DownloadStatus.DOWNLOADING);

    const priceListsServiceArgs = {
      debtorCode: this.debtor,
      params: {
        locale: this.locale,
        country: this.country || undefined,
      },
    };

    const downloadPromise =
      download.id === 'product'
        ? getGetProductPriceList(priceListsServiceArgs)
        : getGetPrintPriceList(priceListsServiceArgs);

    try {
      this.downloadsQueue = [
        ...this.downloadsQueue,
        { id: download.id, url: await downloadPromise },
      ];
      this.requestUpdate('downloadQueue');
    } catch (error) {
      this.updateDownloadStatus(download.id, DownloadStatus.ERROR);
      console.error('CC-FE: Request failed for product download url.', error);
    } finally {
      if (this.downloadsQueue.length <= 1) {
        window.location.assign(this.downloadsQueue[0].url);
        this.triggerDownloadStatus(this.downloadsQueue[0].id);
        this.downloadsQueue = [];
      }
    }
  }

  render() {
    return html`
      <fg-downloads
        .downloadStatus=${this.downloadStatus}
        .downloads=${priceListDownloads}
        @download-file=${this.downloadPriceList}
      ></fg-downloads>
    `;
  }
}
